<template>
	<div class="offcn-live-goods">
    <div class="title_box">
      <p class="commerce_title"><span></span>
      <!-- 头部代码 -->
        <!-- <span class="extension"  v-if="!dialogTableVisible">本场带货mi s：
            <span>{{allListData.room && allListData.room.promotionParams ? allListData.room.promotionParams : '暂无'}}
                <span class="set_extension" @click="dialogTableVisible = true">设置</span>
            </span>
        </span> -->
      <!-- 弹窗代码 -->
      <span class="extension_wrapper" >
          <p v-if="allListData.room && allListData.room.promotionParams && setInfo">
              本场带货mis推广码：<span class="linkOne">{{allListData.room.promotionParams}}</span>
              <span class="set_extension" @click="setInfo = false">更改</span>
              <span class="set_extension set_cancel" @click="setExtension(1, '')">删除</span>
          </p>
          <div v-else>
              <p v-if="setInfo">本场带货mis推广码：暂无<span class="set_extension" @click="setInfo = false">设置</span></p>
              <div v-if="!setInfo" class="set_info">
                  <p style="margin-bottom: 4px;">本场带货mis推广码：
                    <el-input type="text" v-model="allListData.room.promotionParams" placeholder="请输入mis推广码" @focus="isCrmUser = false">
                      <!-- <template slot="prepend">mis=</template> -->
                    </el-input>
                    <span class="set_extension" @click="setExtension('', allListData.room.promotionParams)">保存</span>
                    <span class="set_extension set_cancel" @click="setExtension(1, '')">取消</span>
                  </p>
                  <span v-if="isCrmUser" style="color: #D9001B; fontSize: 12px; paddingLeft: 150px;">{{ userErrorMsg }}</span>
            </div>
        </div>
      </span>
      </p>
      <div class="action_bar">
        <div class="input_search">
          <div class="product_search" :class="{'product_search_error': goodsInputError != ''}">
            <span>商品ID:</span>
            <input type="text" placeholder="请输入商品ID" id="addProductIds" v-model="goodsIds" @input="goodsIdInput" @keyup.enter="addGoodsOrCoupons(1)"/>
            <button class="add_product" :disabled="goodsIds.trim() == ''" @click="addGoodsOrCoupons(1)">添加</button>
            <p class="product_error_tips" v-if="goodsInputError != ''">{{goodsInputError}}</p>
          </div>
          <div class="coupon_search" :class="{'coupon_search_error': couponsInputError != ''}">
            <span>优惠码ID:</span>
            <input type="text" placeholder="请输入优惠券ID" id="addCouponIds" v-model="couponsIds" @input="couponsIdInput" @keyup.enter="addGoodsOrCoupons(2)"/>
            <button class="add_coupon" :disabled="couponsIds.trim() == ''" @click="addGoodsOrCoupons(2)">添加</button>
            <p class="coupon_error_tips" v-if="couponsInputError != ''">{{couponsInputError}}</p>
          </div>
          <button class="export_btn" @click="exportData">导出数据</button>
          <button class="export_data_btn" @click="exportDataFunnel">数据漏斗导出</button>
        </div>
      </div>
      <div class="action_bar">
        <div class="tag_box">
          <p><span @click="addTagVisile = true"><i class="el-icon-plus"></i>标签管理（{{tagSelectArr.length}}）</span>最多添加10个标签</p>
        </div>
        <p class="isclose"><span @click="changeCheck" :class="[ischeck ? 'check' : 'notcheck']"></span>学员可关闭讲解卡片</p>
      </div>
    </div>
    <div class="main_tab_box">
      <div class="product_list" onselectstart="return false" v-if="allListData.liveGoodsList && allListData.liveGoodsList.length > 0">
        <draggable v-model="allListData.liveGoodsList" filter=".invalid" chosen-class="chosen" force-fallback="true" :move="dragGoodsMove" group="allGoodsList" @update="dragListUpdate($event, allListData.liveGoodsList, 1)" :options="{animation:200}">
          <div v-for="(list, index) in allListData.liveGoodsList" :key="index">
            <div class="product_item" v-if="list.type==1">
              <div class="item_main" :class="{invalid: list.goods.pubStatus == 1 || list.goods.pubStatus == 3}">
                <p class="item_detail">
                  <span class="drag_sign"></span>
                  本次直播:成单量<span class="order_num">{{list.goods.countRoomIdOrder && list.goods.countRoomIdOrder.allOrderCount}}</span>&nbsp;&nbsp;
                  已支付<span class="pay_num">{{list.goods.countRoomIdOrder && list.goods.countRoomIdOrder.paidOrderCount}}</span>单
                  <span class="live_status" v-if="list.goods.pubStatus == 1 || list.goods.pubStatus == 3">商品已失效</span>
                </p>
                <div class="product_info">
                  <p class="info_left"><span class="rank">{{index + 1}}</span><img :src="list.goods.pictures[0].indexOf('dl.zgjsks.com') != -1 ? list.goods.pictures[0] :  `//s.eoffcn.com/${list.goods.pictures[0]}`"></p>
                  <div class="info_right">
                    <p class="info_name">
                      <span class="conversion" v-if='conversion(list.goods)'>转化课</span>
                      「ID{{list.goods.goodsId}}」{{list.goods.name}}<span class="view" @click="previewGoods(list.goods.goodsId)"></span>
                      <span class="stock" v-if="list.goods.goodsId.stock - list.goods.allOrderCount > 0">仅剩{{list.goods.goodsId.stock - list.goods.allOrderCount}}件</span>
                    </p>
                    <div class="activity_info" v-if="list.goods.activity && list.goods.activity.title">
                      <div class="activity_title"><img src="./img/activity_icon.png">{{list.goods.activity.title}}</div>
                      <div class="activity_time" v-if="checkActivityGoodsTime(list.goods.activity)">
                        <span class="timeHas">距离活动结束还剩</span>
                        <h3 style="display:flex">
                        <div v-if="getActivitySurplusTime(list.surplusTime, 'day') >= 1">
                          <span class="time">{{ getActivitySurplusTime(list.surplusTime, 'day')}}</span>
                          <span>天</span>
                        </div>
                        <span class="time">{{getActivitySurplusTime(list.surplusTime, 'hour')}}</span>
                        <span>:</span>
                        <span class="time">{{getActivitySurplusTime(list.surplusTime, 'minute')}}</span>
                        <span>:</span>
                        <span class="time">{{getActivitySurplusTime(list.surplusTime, 'second') }}</span>
                        </h3>
                      </div>
                    </div>
                    <div class="info_bottom">
                      <span class="price">¥{{getPriceByGood(list.goods)}}</span>
                      <span class="old_price" v-if="list.goods.displayPrice > 0">¥{{list.goods.displayPrice / 100}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <textarea class="item_remark" placeholder="备注内容,此内容不会展示给学员" v-model="list.remark" @blur="setGoodsOrCouponsRemark(list.id, list.remark)"></textarea> -->
              <div class="item_select">
                <el-select
                  v-model="list.tagIds"
                  placeholder="设置标签"
                  multiple
                  collapse-tags
                  @change="changeTag"
                  @visible-change="(e) => { changeTagFun(e, list) }"
                  @remove-tag="(e) => { changeTagFun(e, list) }"
                >
                  <el-option
                    v-for="item in tagSelectArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <span class="recommend" :class="{forbidden: list.remindStatus == 1 && (list.goods.pubStatus == 1 || list.goods.pubStatus == 3)}" @click="recommendGoods(list.remindStatus, list.goods.goodsId, list, list.goods.pubStatus)"><span>{{list.remindStatus == 1? '讲解': list.remindStatus == 2? '取消讲解': ''}}</span></span>
              <span class="delete" :class="{forbidden: list.remindStatus == 2}" @click="confirmTip('确认删除该商品吗?', 'delete', list.id, allListData.liveGoodsList, list.remindStatus)">删除</span>
            </div>
            <div class="coupon_item" v-if="list.type==2">
              <div class="item_main" :class="{invalid: new Date(list.coupon.validEndTime) < new Date()}">
                <p class="item_detail">
                  <span class="drag_sign"></span>
                  本次直播:领取量<span class="order_num">{{list.coupon.takeCount}}</span>&nbsp;&nbsp;
                  使用量<span class="pay_num">{{list.coupon.usedCount}}</span>
                  <span class="live_status" v-if='new Date(list.coupon.validEndTime) < new Date()'>优惠券已失效</span>
                </p>
                <div class="coupon_info">
                  <div class="info_left">
                    <span class="rank">{{index + 1}}</span>
                    <div class="coupon_left">
                      <span class="coupon_name">{{list.coupon.couponMoney / 100}}元</span><span>{{list.coupon.type == 1?`满${list.coupon.withAmount / 100}元可用`:list.coupon.type == 2?'无使用门槛':''}}</span>
                    </div>
                  </div>
                  <div class="info_right">
                    <p class="info_name">「ID{{list.coupon.couponId}}」{{list.coupon.name}}</p>
                    <p class="cycle">有效期:{{transformCouponsDate(list.coupon.validStartTime)}}~{{transformCouponsDate(list.coupon.validEndTime)}}</p>
                  </div>
                </div>
              </div>
              <div class="item_select item_select_coupon">优惠券不支持设置标签</div>
              <span class="recommend" :class="{forbidden: list.remindStatus == 1 && new Date(list.coupon.validEndTime) < new Date()}" @click="recommendCoupons(list.remindStatus, list.coupon.couponId, list, new Date(list.coupon.validEndTime) < new Date())"><span>{{list.remindStatus == 1? '讲解': list.remindStatus == 2? '取消讲解': ''}}</span></span>
              <span class="delete" :class="{forbidden: list.remindStatus == 2}" @click="confirmTip('确认删除该优惠券吗?', 'delete', list.id, allListData.liveGoodsList, list.remindStatus)">删除</span>
            </div>
          </div>
        </draggable>
      </div>
      <div class="no_product" v-else>
        <img src="./img/no_product.png">
        <p>还没有添加过商品</p>
      </div>
    </div>
    <!-- <el-dialog class="extension_wrapper" :visible.sync="dialogTableVisible">
      <p v-if="allListData.room && allListData.room.promotionParams && setInfo">本场带货mis推广码：{{allListData.room.promotionParams}}
        <span class="set_extension" @click="setInfo = false">更改</span><span class="set_extension set_cancel" @click="setExtension(1, '')">删除</span>
      </p>
      <div v-else>
        <p v-if="setInfo">本场带货mis推广码：暂无<span class="set_extension" @click="setInfo = false">设置</span></p>
        <div v-if="!setInfo" class="set_info">
          <p>本场带货mis推广码：<input type="text" v-model="allListData.room.promotionParams" placeholder="请输入推广商品链接后缀">
          <span class="set_extension" @click="setExtension('', allListData.room.promotionParams)">保存</span><span class="set_extension set_cancel" @click="setExtension(1, '')">删除</span>
        </p>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog
      :visible.sync="addTagVisile"
      title="标签管理"
      width="30%"
      class="add_tag_box"
    >
      <draggable v-model="tagSelectArr" draggable=".tag_item" chosen-class="tag_chosen" force-fallback="true" group="allTagsList" @update="dragTagsUpdate($event, tagSelectArr, 1)" :options="{animation:200}">
        <div class="tag_item" v-for="(i, index) in tagSelectArr" :key="index">
          <span>{{ index + 1 }}&nbsp;{{ i.name }}</span><span><a @click="innerVisible = true; isEdit = true; tagObj = i; tagName = i.name">编辑</a><a @click="delTagFun(i)">删除</a></span>
        </div>
      </draggable>
      <span v-if="tagSelectArr.length < 10" class="add_btn" @click="innerVisible = true; tagObj = {}; tagName = ''">添加标签</span>
      <el-dialog
        width="25%"
        :visible.sync="innerVisible"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        custom-class="add_tag_box_inner"
      >
        <h3 class="tag_dialog_title">{{isEdit ? '编辑' : '添加'}}标签</h3>
        <el-input v-model="tagName" placeholder="请输入6字以内的名称" maxlength="6" @blur="checkIptValue()" @focus="tagNameError = false; tagNameErrorMsg = ''"></el-input>
        <span v-if="tagNameError" style="color: #D9001B; font-size: 12px;">{{tagNameErrorMsg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false; tagNameError = false">取 消</el-button>
          <el-button type="primary" @click="addTagFun()">保存</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery'
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      baseUrl: '',
      exportUrl: '',
      goodsIds: '',
      couponsIds: '',
      goodsInputError: '',
      couponsInputError: '',
      promotionParams: '',
      allListData: [],
      setInfo: true,
      ischeck: false,
      dialogTableVisible: false,
      allProductTimer: null,
      goodsCount: 1,
      addFlag: false,
      addTagVisile: false,
      innerVisible: false, //  添加商品标签内层弹窗
      tagName: '', // 标签的名称
      tagNameError: false, // 标签错误提示
      tagNameErrorMsg: '', // 提示文案
      tagSelectArr: [], // 当前直播间的标签数组
      isEdit: false, // 是否是编辑
      tagArrName: '', // 每个商品选择的标签
      tagObj: {}, // 当前编辑的标签
      setTagArr: [], // 设置的商品标签
      isCrmUser: false, // 是否是crm用户
      userErrorMsg: ''
    }
  },
  components: {
    draggable
  },
  methods: {
    openLoading () {
      this.loading = this.$loading({
        lock: true,
        customClass: 'offcn-loading',
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
    },
    closeLoading () {
      this.loading.close()
    },
    // 设置带货推广
    async setExtension (type, promotionParams) {
      let that = this
      let data = {}
      if (type === 1) {
        data = {
          roomId: this.$route.query.roomid,
          canCloseExplain: 0,
          promotionParams: promotionParams
        }
      } else {
        if (promotionParams) {
          // 只能以mis=开头
          if ((promotionParams.indexOf('mis=') === -1 && type !== 1) || (promotionParams.lastIndexOf('mis=') !== 0)) {
            this.isCrmUser = true
            this.userErrorMsg = '请输入mis推广码，内容格式为“mis=工号”'
            return false
          }
          // 判断用户是否已经注册了crm
          let result = await $.ajax({
            url: this.baseUrl + `/live_goods/checkRoomParams`,
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify({ params: promotionParams, room_id: this.$route.query.roomid })
          })
          if (result && result.code !== 0) {
            this.isCrmUser = true
            this.userErrorMsg = '未设置推广属性，请到电商后台-我的推广-个人中心设置过推广码'
            return false
          }
        }
        data = {
          roomId: this.$route.query.roomid,
          canCloseExplain: this.ischeck ? 1 : 0,
          promotionParams: promotionParams
        }
      }
      $.ajax({
        url: this.baseUrl + `/live_goods/saveRoomInfo`,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function (res) {
          if (res.code === 0) {
            that.dialogTableVisible = false
            that.setInfo = true
            that.refreshList()
            if (!webAccessor) return // eslint-disable-line
            webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
              'path': 'live/set_promotionParams',
              'data': {
                dataInfo: promotionParams,
                roomId: that.$route.query.roomid
              }
            }))
          }
        }
      })
    },
	  // 导出直播带货数据
	  exportData () {
		  if (this.checkVersion()) {
        let that = this
        let roomId = this.$route.query.roomid
        $.ajax({
          url: this.baseUrl + `/live/export?room_id=${roomId}`,
          type: 'get',
          dataType: 'json',
          success: function (data) {
            if (data.code === 0) {
              // 导出带货数据成功
              var result = data.data
              console.log('导出带货成功')
              console.log(result)
              window.open(that.exportUrl + result.path, '_blank')
            } else {
              alert(data.message)
            }
          }
        })
      } else {
        // 低版本提示升级
        this.$msgbox({
          message: '当前版本无法使用该功能，请升级至v3.2.1及以上',
          type: 'warning'
        })
		  }
	  },
    exportDataFunnel () {
      if (this.checkVersion()) {
        let that = this
        let roomId = this.$route.query.roomid
        $.ajax({
          url: this.baseUrl + `/live/export_goods`,
          type: 'post',
          data: {
            'roomId': roomId
          },
          success: function (data) {
            if (data.code === 0) {
              // 导出带货数据成功
              var result = data.data
              console.log('导出带货成功')
              console.log(result)
              window.open(that.exportUrl + result.path, '_blank')
            } else {
              alert(data.message)
            }
          }
        })
      } else {
        // 低版本提示升级
        this.$msgbox({
          message: '当前版本无法使用该功能，请升级至v3.2.1及以上',
          type: 'warning'
        })
		  }
    },
    changeCheck () {
      this.ischeck = !this.ischeck
      this.setExtension('', this.allListData.room.promotionParams)
      if (this.ischeck) {
        if (!webAccessor) return // eslint-disable-line
        webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
          'path': 'live/explain_close',
          'data': {
            dataInfo: true,
            roomId: this.$route.query.roomid
          }
        }))
      } else {
        if (!webAccessor) return // eslint-disable-line
        webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
          'path': 'live/explain_open',
          'data': {
            dataInfo: false,
            roomId: this.$route.query.roomid
          }
        }))
      }
    },
    // 判断当前版本号是否满足版本功能
    checkVersion () {
      var version = this.$route.query.version ? this.$route.query.version.split('_')[0] : null
      if (version) {
        let versionJs = '3.2.0'
        let arr = [version, versionJs]
        arr.sort((a, b) => {
          let i = 0
          const arr1 = a.split('.')
          const arr2 = b.split('.')
          while (true) {
            const s1 = Number(arr1[i])
            const s2 = Number(arr2[i++])
            if (s1 === s2) continue
            return s2 - s1
          }
        })
        return arr[0] === version
      } else {
        return false
      }
    },
    // 教师端通过房间号获取直播带货列表
    getGoodsList () {
      let that = this
      let roomId = this.$route.query.roomid
      $.ajax({
        url: this.baseUrl + '/live_goods/newList',
        type: 'post',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify({
          roomId: roomId,
          getStats: +1
        }),
        success: function (res) {
          if (res.code === 0) {
            console.log(res.data, 'image.pngimage.pngimage.pngimage.png')
            res.data.liveGoodsList = res.data.liveGoodsList.map(e => {
              var surplusTime = ''
              if (e.goods.goodsId) {
                surplusTime = (new Date(e.goods.activity.endTime) - new Date()) / 1000
              }
              // that.tagSelectArr.filter(i => { console.log(i, typeof i) })
              e.tagIds = e.tagIds.filter(i => that.tagSelectArr.some(v => v.id === i))
              return {
                surplusTime: surplusTime,
                tagIds: e.tagIds.filter(i => that.tagSelectArr.some(v => v.id === i)),
                ...e
              }
            })
            that.allListData = res.data
            that.ischeck = res.data.room.canCloseExlain
            if (that.addFlag) {
            if (!webAccessor) return // eslint-disable-line
              setTimeout(function () {
                    webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                  'path': 'on_shelves',
                  'data': {
                    dataInfo: that.allListData.liveGoodsList[0],
                    roomId: roomId
                  }
                }))
                that.addFlag = false
              }, 500)
            }
          } else {
            alert(res.message)
          }
        }
      })
    },
    // 校验日期是否在有效期内
    testDateValidity (startTime, endTime) {
      var isValidate = false
      var now = new Date().getTime()
      var startTimeMs = new Date(startTime).getTime()
      var endTimeMs = new Date(endTime).getTime()
      if (now < endTimeMs && now >= startTimeMs) {
        isValidate = true
      }
      return isValidate
    },
    // 定时器刷新活动结束时间
    refreshActivityTime () {
      var that = this
      if (that.allListData) {
        clearInterval(that.allProductTimer)
        that.allProductTimer = setInterval(function () {
          that.allListData.liveGoodsList && that.allListData.liveGoodsList.length > 0 && that.allListData.liveGoodsList.map(e => {
            if (e.surplusTime === '' && e.surplusTime < 0) return
            e.surplusTime--
          })
        }, 1000)
      }
    },
    goodsIdInput () {
      this.goodsIds = this.goodsIds.replace(/[^\d]/g, '')
      if (this.goodsIds === '') this.goodsInputError = ''
    },
    couponsIdInput () {
      this.couponsIds = this.couponsIds.replace(/[^\d]/g, '')
      if (this.couponsIds === '') this.couponsInputError = ''
    },
    // 添加商品或优惠券
    addGoodsOrCoupons (type) {
      // type 1:添加商品 2:添加优惠券
      var that = this
      var roomId = this.$route.query.roomid
      if (type === 1) {
        if (that.goodsIds.trim() === '') return
      } else if (type === 2) {
        if (that.couponsIds.trim() === '') return
      }
      $.ajax({
        url: this.baseUrl + `/live_goods/newAdd`,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify({
          roomId: roomId,
          createName: '',
          list: [{
            goodsId: Number(that.goodsIds),
            couponId: Number(that.couponsIds),
            rank: this.allListData.liveGoodsList.length + 1
          }]
        }),
        success: function (res) {
          if (res.code === 0) {
            // 添加成功
            that.$message({
              message: '添加成功',
              type: 'success',
              duration: 1000
            })
            // vue渲染之后el-message不在当前组件内 deep深度渗透样式不生效 采用以下方式
            var el = document.querySelector('.el-message.el-message--success')
            if (el) {
              el.style.top = '40%'
              el.style.minWidth = 'auto'
            }
            that.addFlag = true
            that.goodsIds = ''
            that.couponsIds = ''
            // 取消输入框错误提示
            that.goodsInputError = ''
            that.couponsInputError = ''
            that.refreshList()
            // if (!webAccessor) return // eslint-disable-line
            // setTimeout(function () {
            //   webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
            //     'path': 'on_shelves',
            //     'data': {
            //       dataInfo: that.allListData.liveGoodsList[0],
            //       roomId: roomId
            //     }
            //   }))
            // }, 500)
          } else {
            // 添加输入框错误提示
            if (type === 1) {
              that.goodsInputError = res.message
            } else if (type === 2) {
              that.couponsInputError = res.message
            }
          }
        }
      })
    },
    dragGoodsMove (e) {
      if (e.relatedContext.element.pub_status === 1 || e.relatedContext.element.pub_status === 3) return false
      return true
    },
    // 拖动列表方法
    async dragListUpdate (evt, list) {
      evt.preventDefault()
      let that = this
      let newGoodsList = []
      var roomId = this.$route.query.roomid
      newGoodsList = await list.map((item, index) => {
        // console.log(item, list.length, index, 'list.length - indexlist.length - index')
        return {
          id: item.id,
          rank: index + 1
        }
      })
      $.ajax({
        url: this.baseUrl + `/live_goods/newSort`,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify({
          roomId: roomId,
          updater_name: '',
          list: newGoodsList
        }),
        success: function (res) {
          if (res.code === 0) {
            // 排序设置成功
            console.log('排序设置成功')
            that.refreshList()
            if (!webAccessor) return // eslint-disable-line
            setTimeout(function () {
              webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                'path': 'sort_list',
                'data': {
                  dataInfo: that.allListData.liveGoodsList,
                  roomId: roomId
                }
              }))
            }, 500)
          } else {
            alert(res.message)
          }
        }
      })
    },
    // 拖动标签方法
    async dragTagsUpdate (evt, list) {
      evt.preventDefault()
      let that = this
      let newTagsList = []
      var roomId = this.$route.query.roomid
      newTagsList = await list.map((item, index) => {
        // console.log(item, list.length, index, 'list.length - indexlist.length - index')
        return {
          id: item.id,
          sort: index + 1
        }
      })
      $.ajax({
        url: this.baseUrl + `/live_goods/roomTagSort`,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify({
          roomId: roomId,
          list: newTagsList
        }),
        success: function (res) {
          if (res.code === 0) {
            // 排序设置成功
            console.log('标签排序设置成功')
            that.getTagList()
            if (!webAccessor) return // eslint-disable-line
            setTimeout(function () {
              webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                'path': 'sort_tag',
                'data': {
                  dataInfo: that.tagSelectArr,
                  roomId: roomId
                }
              }))
            }, 500)
          } else {
            alert(res.message)
          }
        }
      })
    },
    // 判断活动商品是否在活动中
    checkActivityGoodsTime (activity) {
      var startTime = new Date(activity.startTime)
      var endTime = new Date(activity.endTime)
      if (new Date() <= endTime && new Date() >= startTime) {
        // 活动中
        return true
      }
      return false
    },
    // 获取活动中商品结束剩余时间
    getActivitySurplusTime (surplusTime, type) {
      if (surplusTime === '') return ''
      var day = Math.floor((surplusTime / (3600 * 24)))
      var hour = Math.floor((surplusTime / 3600) % 24) <= 9 ? '0' + Math.floor((surplusTime / 3600) % 24) : Math.floor((surplusTime / 3600) % 24)
      var minute = Math.floor((surplusTime / 60) % 60) <= 9 ? '0' + Math.floor((surplusTime / 60) % 60) : Math.floor((surplusTime / 60) % 60)
      var second = Math.floor(surplusTime % 60) <= 9 ? '0' + Math.floor(surplusTime % 60) : Math.floor(surplusTime % 60)
      if (type === 'day') return day
      if (type === 'hour') return hour
      if (type === 'minute') return minute
      if (type === 'second') return second
      return ''
    },
    // 转化课
    conversion (item) {
      let price = ''
      // 活动商品
      if (item.activity && this.testDateValidity(item.activity.startTime, item.activity.endTime)) {
        if (item.activity.minActivityPrice === item.activity.maxActivityPrice) {
          price = item.activity.minActivityPrice
        } else {
          price = `${item.activity.minActivityPrice} - ${item.activity.maxActivityPrice}`
        }
      } else {
        if (item.minPrice === item.maxPrice) {
          price = item.minPrice
        } else {
          price = `${item.minPrice} - ${item.maxPrice}`
        }
      }
      if (price > 10000) {
        return price
      }
    },
    // 获取商品价格
    getPriceByGood (item) {
      let price = ''
      // 活动商品
      if (item.activity && this.testDateValidity(item.activity.startTime, item.activity.endTime)) {
        if (item.activity.hasSpecification === 1) { // 有规格
          // 价格展示一个
          if (item.activity.minActivityPrice === item.activity.maxActivityPrice) {
            price = item.activity.minActivityPrice / 100
          } else {
            price = `${item.activity.minActivityPrice / 100} - ${item.activity.maxActivityPrice / 100}`
          }
        } else { // 无规格
          price = item.activity.promotionPrice / 100
        }
      } else {
        if (item.minPrice === item.maxPrice) {
          price = item.minPrice / 100
        } else {
          price = `${item.minPrice / 100} - ${item.maxPrice / 100}`
        }
      }
      return price
    },
    // 预览商品
    previewGoods (goodsId) {
      if (this.checkVersion()) {
        let url = ''
        if (location.href.indexOf('teacher.offcncloud.com') !== -1) {
          // url = `//i.eoffcn.com/c/${goodsId}`
          url = `//i.offcn.com/c/${goodsId}`
        } else {
          url = `//i.t.eoffcn.com/c/${goodsId}`
        }
        window.open(url, '_blank')
      } else {
        // 低版本提示升级
        this.$msgbox({
          message: '当前版本无法使用该功能，请升级至v3.2.1及以上',
          type: 'warning'
        })
      }
    },
    // 讲解商品或取消讲解商品
    recommendGoods (status, id, dataInfo, type) {
      if (status === 1 && (type === 1 || type === 3)) return
      // status 1:取消讲解 2:讲解
      var that = this
      that.goodsCount = 1
      this.allListData.liveGoodsList.forEach(e => {
        if (e.remindStatus === 2) {
          that.goodsCount++
        }
      })
      if (status === 1) {
        if (that.goodsCount > 1) {
          let h = this.$createElement
          this.$msgbox({
            type: 'warning',
            message: h('p', null, [h('span', null, '有其他商品正在讲解中，是否取消其他商品讲解？')]),
            showCancelButton: true,
            confirmButtonText: '取消讲解',
            cancelButtonText: '多个同时讲解',
            distinguishCancelAndClose: true,
            callback: function (action) {
              if (action === 'confirm') { // 取消讲解
                that.allListData.liveGoodsList.forEach(e => {
                  if (e.remindStatus === 2 && e.type === 1) {
                    that.cancelGoodsRemind(e.goods.goodsId, e)
                  } else if (e.remindStatus === 2 && e.type === 2) {
                    that.cancelCouponsRemind(e.coupon.couponId, e)
                  }
                })
                that.goodsRemind(id, dataInfo)
              } else if (action === 'cancel') { // 多个同时讲解
                that.goodsRemind(id, dataInfo)
              }
            }
          })
        } else {
          this.goodsRemind(id, dataInfo)
        }
      } else if (status === 2) {
        this.cancelGoodsRemind(id, dataInfo)
      }
    },
    // 商品讲解
    goodsRemind (id, dataInfo) {
      this.openLoading()
      let that = this
      let roomId = this.$route.query.roomid
      $.ajax({
        url: that.baseUrl + `/live_goods/remind`,
        type: 'post',
        data: {
          room_id: roomId,
          goods_id: id,
          update_name: ''
        },
        success: function (data) {
          that.closeLoading()
          if (data.code === 0) {
            var result = data.data
            if (result.isSuccess) {
              // 发布提醒成功
              console.log('商品发布提醒成功')
              that.refreshList()
              // 和客户端交互
              if (!webAccessor) return // eslint-disable-line
              webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                'path': 'remind_purchase',
                'data': {
                  dataInfo: {
                    ...dataInfo,
                    remindStatus: 2
                  },
                  type: 'goods',
                  roomId: roomId
                }
              }))
            }
          } else {
            alert(data.message)
          }
        }
      })
    },
    // 商品取消讲解
    cancelGoodsRemind (id, dataInfo) {
      this.openLoading()
      let that = this
      let roomId = this.$route.query.roomid
      $.ajax({
        url: this.baseUrl + `/live_goods/cancel_remind`,
        type: 'post',
        data: {
          room_id: roomId,
          goods_id: id,
          update_name: ''
        },
        success: function (data) {
          that.closeLoading()
          if (data.code === 0) {
            var result = data.data
            if (result.isSuccess) {
              // 取消推荐成功
              console.log('商品取消提醒成功')
              that.refreshList()
              // 和客户端交互
              if (!webAccessor) return // eslint-disable-line
              webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                'path': 'cancel_remind',
                'data': {
                  dataInfo: {
                    ...dataInfo,
                    remindStatus: 1
                  },
                  type: 'goods',
                  roomId: roomId
                }
              }))
            }
          } else {
            alert(data.message)
          }
        }
      })
    },
    // 优惠券讲解
    couponsRemind (id, dataInfo) {
      this.openLoading()
      let that = this
      let roomId = this.$route.query.roomid
      $.ajax({
        url: this.baseUrl + `/live_goods/coupon_remind`,
        type: 'post',
        data: {
          room_id: roomId,
          coupon_id: id,
          update_name: ''
        },
        success: function (data) {
          that.closeLoading()
          if (data.code === 0) {
            var result = data.data
            if (result.isSuccess) {
              // 优惠券发布提醒成功
              console.log('优惠券发布提醒成功')
              that.refreshList()
              // 和客户端交互
              if (!webAccessor) return // eslint-disable-line
              webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                'path': 'remind_purchase',
                'data': {
                  dataInfo: {
                    ...dataInfo,
                    remindStatus: 2
                  },
                  type: 'coupons',
                  roomId: roomId
                }
              }))
            }
          } else {
            alert(data.message)
          }
        }
      })
    },
    // 优惠券取消讲解
    cancelCouponsRemind (id, dataInfo) {
      this.openLoading()
      let that = this
      let roomId = this.$route.query.roomid
      $.ajax({
        url: this.baseUrl + `/live_goods/coupon_cancel_remind`,
        type: 'post',
        data: {
          room_id: roomId,
          coupon_id: id,
          update_name: ''
        },
        success: function (data) {
          that.closeLoading()
          if (data.code === 0) {
            var result = data.data
            if (result.isSuccess) {
              // 取消推荐成功
              console.log('优惠券取消提醒成功')
              that.refreshList()
              // 和客户端交互
              if (!webAccessor) return // eslint-disable-line
              webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                'path': 'cancel_remind',
                'data': {
                  dataInfo: {
                    ...dataInfo,
                    remindStatus: 1
                  },
                  type: 'coupons',
                  roomId: roomId
                }
              }))
            }
          } else {
            alert(data.message)
          }
        }
      })
    },
    // 提示弹窗
    confirmTip (msg, menuType, listId, list, type) {
      if (type === 2) return
      var that = this
      var h = this.$createElement
      this.$msgbox({
        type: 'warning',
        showClose: false,
        showCancelButton: true,
        closeOnClickModal: false,
        cancelButtonClass: 'message_cancel_button',
        confirmButtonClass: 'message_confirm_button',
        message: h('p', null, [h('span', null, msg)]),
        callback: function (action, instance) {
          if (action === 'confirm') {
            console.log('点击了确认')
            if (menuType === 'delete') {
              that.deleteGoodsOrCoupons(listId, list)
            }
          } else if (action === 'cancel') {
            console.log('点击了取消')
          }
        }
      })
    },
    // 重新获取列表刷新数据
    refreshList () {
      let that = this
      that.getGoodsList()
    },
    // 删除房间号内的商品或优惠券
    deleteGoodsOrCoupons (listId, list) {
      var that = this
      var roomId = this.$route.query.roomid
      list.map((item, index) => {
        if (listId === item.id) {
          list.splice(index, 1)
        }
      })
      let newGoodsList = list.map((item, index) => {
        return {
          id: item.id,
          // rank: list.length - index
          rank: index + 1
        }
      })
      $.ajax({
        url: this.baseUrl + `/live_goods/newDel`,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify({
          roomId: roomId,
          ids: [listId],
          updater_name: '',
          list: newGoodsList
        }),
        success: function (res) {
          if (res.code === 0) {
            // 删除成功
            that.$message({
              message: '删除成功',
              type: 'success',
              duration: 1000
            })
            // vue渲染之后el-message不在当前组件内 deep深度渗透样式不生效 采用以下方式
            var el = document.querySelector('.el-message.el-message--success')
            if (el) {
              el.style.top = '40%'
              el.style.minWidth = 'auto'
            }
            that.refreshList()
            if (!webAccessor) return // eslint-disable-line
            setTimeout(function () {
              webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                'path': 'off_shelf',
                'data': {
                  dataInfo: that.allListData.liveGoodsList,
                  roomId: roomId
                }
              }))
            }, 500)
          } else {
            alert(res.message)
          }
        }
      })
    },
    // 商品或优惠券设置备注
    setGoodsOrCouponsRemark (id, remark) {
      var that = this
      $.ajax({
        url: this.baseUrl + `/live_goods/setRemarks`,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify({
          ids: [id],
          remarks: [remark],
          updater_name: ''
        }),
        success: function (data) {
          if (data.code === 0) {
            var result = data.data
            // 备注设置成功
            if (result.isSuccess) {
              console.log('备注设置成功')
              that.refreshList()
            }
          } else {
            alert(data.message)
          }
        }
      })
    },
    // date 格式转化为2020.03.31显示
    transformCouponsDate (date) {
      date = new Date(date)
      let Y = date.getFullYear()
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let D = date.getDate()
      return Y + '.' + M + '.' + D
    },
    // 讲解优惠券或取消讲解优惠券
    recommendCoupons (status, id, dataInfo, type) {
      if (type && status === 1) return
      // status 1:取消讲解 2:讲解
      var that = this
      that.goodsCount = 1
      this.allListData.liveGoodsList.forEach(e => {
        if (e.remindStatus === 2) {
          that.goodsCount++
        }
      })
      if (status === 1) {
        if (that.goodsCount > 1) {
          let h = this.$createElement
          this.$msgbox({
            type: 'warning',
            message: h('p', null, [h('span', null, '有其他商品正在讲解中，是否取消其他商品讲解？')]),
            showCancelButton: true,
            confirmButtonText: '取消讲解',
            cancelButtonText: '多个同时讲解',
            distinguishCancelAndClose: true,
            callback: function (action) {
              if (action === 'confirm') { // 取消讲解
                that.allListData.liveGoodsList.forEach(e => {
                  if (e.remindStatus === 2 && e.type === 1) {
                    that.cancelGoodsRemind(e.goods.goodsId, e)
                  } else if (e.remindStatus === 2 && e.type === 2) {
                    that.cancelCouponsRemind(e.coupon.couponId, e)
                  }
                })
                that.couponsRemind(id, dataInfo)
              } else if (action === 'cancel') { // 多个同时讲解
                that.couponsRemind(id, dataInfo)
              }
            }
          })
        } else {
          that.couponsRemind(id, dataInfo)
        }
      } else if (status === 2) {
        that.cancelCouponsRemind(id, dataInfo)
      }
    },
    // 添加标签
    addTagFun () {
      console.log(this.tagObj, JSON.stringify(this.tagObj))
      // 汉字正则
      var reg = /^[\u4e00-\u9fa5]+$/g
      if (!this.tagName) {
        this.tagNameError = true
        this.tagNameErrorMsg = '请输入名称'
      } else if (!reg.test(this.tagName)) {
        this.tagNameError = true
        this.tagNameErrorMsg = '只支持汉字'
      }
      if (this.tagNameError) return false
      let that = this
      let roomId = this.$route.query.roomid
      if (that.tagObj && JSON.stringify(that.tagObj) !== '{}') {
        $.ajax({
          url: that.baseUrl + '/live_goods/roomTagUpdate',
          type: 'post',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({
            roomId: roomId,
            name: that.tagName,
            updatedBy: window.sessionStorage.getItem('username'),
            id: that.tagObj.id
          }),
          success: function (res) {
            console.log(res)
            if (res.code === 0) {
              that.innerVisible = false
              that.$message({
                message: '编辑成功',
                type: 'success',
                duration: 1000
              })
              // vue渲染之后el-message不在当前组件内 deep深度渗透样式不生效 采用以下方式
              var el = document.querySelector('.el-message.el-message--success')
              if (el) {
                el.style.top = '40%'
                el.style.minWidth = 'auto'
              }
              that.getTagList()
              if (!webAccessor) return // eslint-disable-line
              setTimeout(function () {
                webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                  'path': 'sort_list',
                  'data': {
                    dataInfo: that.allListData.liveGoodsList,
                    roomId: roomId
                  }
                }))
              }, 500)
            }
            if (res.code === 10000) {
              that.tagNameError = true
              that.tagNameErrorMsg = res.message
            }
          }
        })
      } else {
        $.ajax({
          url: this.baseUrl + '/live_goods/roomTagAdd',
          type: 'post',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({
            roomId: roomId,
            name: that.tagName,
            createdBy: window.sessionStorage.getItem('username')
          }),
          success: function (res) {
            if (res.code === 0) {
              that.innerVisible = false
              that.$message({
                message: '添加成功',
                type: 'success',
                duration: 1000
              })
              // vue渲染之后el-message不在当前组件内 deep深度渗透样式不生效 采用以下方式
              var el = document.querySelector('.el-message.el-message--success')
              if (el) {
                el.style.top = '40%'
                el.style.minWidth = 'auto'
              }
              that.getTagList()
              if (!webAccessor) return // eslint-disable-line
              setTimeout(function () {
                webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                  'path': 'sort_list',
                  'data': {
                    dataInfo: that.allListData.liveGoodsList,
                    roomId: roomId
                  }
                }))
              }, 500)
            }
            if (res.code === 10000) {
              that.tagNameError = true
              that.tagNameErrorMsg = res.message
            }
          }
        })
      }
    },
    // 校验标签名称
    checkIptValue () {
      // 汉字正则
      var reg = /^[\u4e00-\u9fa5]+$/g
      if (!this.tagName) {
        this.tagNameError = true
        this.tagNameErrorMsg = '请输入名称'
      } else if (!reg.test(this.tagName)) {
        this.tagNameError = true
        this.tagNameErrorMsg = '只支持汉字'
      }
    },
    // 删除标签
    delTagFun (val) {
      let that = this
      let roomId = this.$route.query.roomid
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        $.ajax({
          url: that.baseUrl + '/live_goods/roomTagDel',
          type: 'post',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({
            roomId: roomId,
            id: val.id
          }),
          success: function (res) {
            if (res.code === 0) {
              that.$message({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
              // vue渲染之后el-message不在当前组件内 deep深度渗透样式不生效 采用以下方式
              var el = document.querySelector('.el-message.el-message--success')
              if (el) {
                el.style.top = '40%'
                el.style.minWidth = 'auto'
              }
              that.getTagList()
              that.refreshList()
              if (!webAccessor) return // eslint-disable-line
              setTimeout(function () {
                webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                  'path': 'sort_list',
                  'data': {
                    dataInfo: that.allListData.liveGoodsList,
                    roomId: roomId
                  }
                }))
              }, 500)
            }
          }
        })
      }).catch(() => {})
    },
    // 获取直播间标签列表
    getTagList () {
      let that = this
      let roomId = this.$route.query.roomid
      $.ajax({
        url: this.baseUrl + '/live_goods/roomTagList',
        type: 'post',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify({
          roomId: roomId
        }),
        success: function (res) {
          if (res.code === 0) {
            that.tagSelectArr = res.data
          }
        }
      })
    },
    // 选择标签
    changeTag (val) {
      console.log(val, 'changeTagchangeTagchangeTag')
      this.setTagArr = val
    },
    // 设置商品标签
    changeTagFun (val, obj) {
      console.log(val, obj, 'val, obj,val, obj,', this.setTagArr, typeof val === 'number')
      let that = this
      let roomId = this.$route.query.roomid
      if (that.setTagArr) {
        // 打开select下拉框且选中的值存在 或 点击了删除的按钮
        if ((!val && that.setTagArr.length >= 0) || typeof val === 'number') {
          $.ajax({
            url: that.baseUrl + '/live_goods/setGoodsTags',
            type: 'post',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({
              roomId: roomId,
              goodsId: obj.goods.goodsId,
              tagIds: that.setTagArr
            }),
            success: function (res) {
              if (res.code === 0) {
                that.$message({
                  message: '设置成功',
                  type: 'success',
                  duration: 1000
                })
                // vue渲染之后el-message不在当前组件内 deep深度渗透样式不生效 采用以下方式
                var el = document.querySelector('.el-message.el-message--success')
                if (el) {
                  el.style.top = '40%'
                  el.style.minWidth = 'auto'
                }
                that.setTagArr = []
                that.getTagList()
                if (!webAccessor) return // eslint-disable-line
                setTimeout(function () {
                  webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                    'path': 'sort_list',
                    'data': {
                      dataInfo: that.allListData.liveGoodsList,
                      roomId: roomId
                    }
                  }))
                }, 500)
              }
              if (res.code === 10000) {
                that.$message({
                  message: res.message,
                  type: 'error'
                })
                // vue渲染之后el-message不在当前组件内 deep深度渗透样式不生效 采用以下方式
                var ele = document.querySelector('.el-message.el-message--error')
                if (ele) {
                  ele.style.top = '40%'
                  ele.style.minWidth = 'auto'
                }
              }
            }
          })
        }
      }
    }
  },
  mounted () {
    if (window.location.host === 'teacher.offcncloud.com') {
      this.baseUrl = 'https://erp.eoffcn.com/api'
      this.exportUrl = 'https://erp.eoffcn.com'
    } else {
      this.baseUrl = 'https://erp.t.eoffcn.com/api'
      this.exportUrl = 'https://erp.t.eoffcn.com'
    }
    this.getTagList()
    this.getGoodsList()
    this.refreshActivityTime()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/deep/ .add_tag_box .el-dialog {
  width: 52%;
  .el-dialog__header{
    border-bottom: 1px solid #c1bebe;
  }
  .el-dialog__body{
    padding: 20px 15px;
  }
  .tag_item{
    display: flex;
    color: #555;
    font-size: 12px;
    justify-content: space-between;
    line-height: 30px;
    span{
      a:nth-child(1){
        color: #000;
        cursor: pointer;
        margin-right: 10px;
      }
      a:nth-child(2){
        color: #D9001B;
        cursor: pointer;
      }
    }
  }
	.add_btn{
		color: #EC808D;
		cursor: pointer;
	}
}
/deep/ .add_tag_box_inner.el-dialog {
  width: 50%;
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    .tag_dialog_title{
      font-size: 14px !important;
      color: #000;
      text-align: center;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .el-input{
      margin-bottom: 5px;
      .el-input__inner{
        height: 32px;
      }
    }
    padding: 18px 20px;
  }
  .el-dialog__footer{
    padding-top: 0;
    .dialog-footer{
      .el-button {
        padding: 5px 8px;
        &.el-button--primary{
          background-color: #de868f;
        }
      }
    }
  }
}
/deep/ .el-popup-parent--hidden {
  .el-message-box__wrapper{
    .el-message-box {
      width: auto !important;
    }
  }
}
/deep/ .el-input{
  max-width: 300px !important;
  .el-input__inner{
    height: 32px;
  }
  .el-input-group__prepend{
    font-size: 14px !important;
    color: #333 !important;
  }
}
.offcn-live-goods {
  padding-top: 166px;
  box-sizing: border-box;
  .title_box{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background: #fff;
    .commerce_title {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      font-weight: bold;
      border-bottom: 1px solid #e6e6e6;
      padding: 24px 20px;
      .extension {
        font-size: 14px;
        margin-right: 94px;
        .set_extension {
          display: inline-block;
          width: 54px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          color: #ffffff;
          border-radius: 4px;
          background: linear-gradient(0deg, #d75b4a 0%, #d33f3a 100%);
          margin-left: 20px;
          cursor: pointer;
        }
        .close {
          display: inline-block;
          width: 13px;
          height: 13px;
          background: url(./img/close.svg);
          margin-left: 80px;
          cursor: pointer;
        }
      }
    }
    .action_bar {
      padding: 0 24px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      .input_search {
        display: flex;
        .product_search, .coupon_search {
          span {
            font-size: 14px;
            vertical-align: middle;
          }
          #addProductIds, #addCouponIds {
            width: 140px;
            height: 32px;
            line-height: 32px;
            border-radius: 4px;
            border: 1px solid #e5e5e5;
            vertical-align: middle;
            font-size: 12px;
            padding: 9px;
            box-sizing: border-box;
            margin: 0 10px;
            outline: none;
          }
          @media screen and (max-width: 800px) {
              #addProductIds, #addCouponIds {
                  width: 82px;
                  margin: 0 6px;
              }
          }
          @media screen and (min-width: 800px) and (max-width: 900px){
              #addProductIds, #addCouponIds {
                  width: 128px;
                  margin: 0 6px;
              }
          }
          .add_product, .add_coupon {
            width: 60px;
            height: 32px;
            background-image: linear-gradient(0deg, #d75b4a 0%, #d33f3a 100%);
            border-radius: 4px;
            font-size: 12px;
            color: #fff;
            border: none;
            vertical-align: middle;
            cursor: pointer;
            margin-right: 20px;
            font-family: "微软雅黑";
          }
          @media screen and (max-width: 900px) {
              .add_product, .add_coupon {
                  width: 44px;
                  margin-right: 10px;
              }
          }
        }
        .export_btn {
          width: 92px;
          height: 32px;
          line-height: 32px;
          border: 1px solid #e6e6e6;
          border-radius: 4px;
          padding-left: 33px;
          font-size: 12px;
          color: #0d152d;
          background: url(./img/export_btn.svg) no-repeat 10px 8px;
          background-size: 14px 14px;
          cursor: pointer;
          font-family: "微软雅黑";
        }
        .export_data_btn{
          width: 122px;
          height: 32px;
          line-height: 32px;
          border: 1px solid #e6e6e6;
          border-radius: 4px;
          padding-left: 33px;
          font-size: 12px;
          color: #0d152d;
          background: url(./img/export_btn.svg) no-repeat 10px 8px;
          background-size: 14px 14px;
          cursor: pointer;
          font-family: "微软雅黑";
          margin-left: 20px;
        }
      }
      .isclose {
        font-size: 12px;
        color: #0d152d;
        .check, .notcheck {
          display: inline-block;
          width: 12px;
          height: 12px;
          vertical-align: middle;
          background: url(./img/checked.svg) no-repeat;
          margin-right: 10px;
        }
        .notcheck {
          background: url(./img/notcheck.svg) no-repeat;
        }
      }
      .tag_box{
        font-size: 12px !important;
        color: #555 !important;
        span{
          color: #2DA2E5 !important;
          cursor: pointer;
        }
      }
    }
  }
  .main_tab_box {
    position: initial;
    > div {
      padding: 0 24px;
    }
    .product_search_error, .coupon_search_error {
      #addProductIds, #addCouponIds {
        border: 1px solid #e60012;
      }
    }
    .product_error_tips, .coupon_error_tips {
      width: 234px;
      color: #e60012;
      font-size: 12px;
      margin: 8px 0 0 60px;
    }
    .coupon_error_tips {
      margin-left: 74px;
    }
    .product_list {
      margin-top: 40px;
      .product_item, .coupon_item {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 10px;
        box-sizing: border-box;
        .invalid {
          p {
            opacity: 0.5;
          }
          .live_status {
            float: right;
            color: #9ca2b1 !important;
            margin-right: 10px;
          }
        }
        .item_main {
          width: 100%;
          height: 100%;
          border: 1px solid #e5e5e5;
          border-radius: 4px;
          box-sizing: border-box;
          .item_detail {
            position: relative;
            height: 32px;
            line-height: 32px;
            background: #fafafa;
            padding-left: 20px;
            .drag_sign {
              position: absolute;
              top: 5px;
              left: 3px;
              width: 10px;
              height: 20px;
              background: url(./img/drag.svg) no-repeat 0 center;
            }
          }
          p {
            font-size: 12px;
            color: #0d152d;
            line-height: 12px;
            .order_num, .pay_num {
              font-size: 14px;
              font-weight: 700;
            }
          }
          .product_info, .coupon_info {
            position: relative;
            display: flex;
            justify-content: space-between;
            padding: 10px;
            .info_left {
              position: relative;
              .rank {
                width: 20px;
                height: 16px;
                line-height: 16px;
                background-color: #ffeaea;
                display: inline-block;
                position: absolute;
                left: 0;
                top: 0;
                font-size: 12px;
                color: #e60012;
                text-align: center;
              }
              img, .coupon_left {
                width: 120px;
                height: 68px;
                float: left;
                border-radius: 4px;
              }
              .coupon_left {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                color: #876941;
                background: url(./img/coupon.png);
                .coupon_name {
                  font-size: 16px;
                  font-weight: bold;
                  color: #d44940;
                  margin-bottom: 4px;
                }
              }
            }
            .info_right {
              width: 100%;
              margin-left: 10px;
              position: relative;
              .info_name {
                font-size: 14px;
                color: #0d152d;
                line-height: 14px;
                margin-top: 10px;
                .conversion {
                  display: inline-block;
                  width: 48px;
                  text-align: center;
                  font-size: 12px;
                  color: #fe895f;
                  border: 1px solid #fe895f;
                  border-radius: 4px;
                }
                .view {
                  display: inline-block;
                  width: 13px;
                  height: 12px;
                  background: url(./img/view.svg) no-repeat;
                  margin-left: 10px;
                }
              }
              .info_bottom {
                width: 100%;
                height: 16px;
                line-height: 16px;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                box-sizing: border-box;
                .price {
                  font-size: 16px;
                  font-weight: 700;
                  color: #e60012;
                  line-height: 16px;
                  vertical-align: middle;
                }
                .old_price {
                  font-size: 12px;
                  color: #949bab;
                  line-height: 12px;
                  vertical-align: middle;
                  text-decoration: line-through;
                }
              }
              .cycle {
                color: #949bab;
                margin-top: 10px;
              }
              .activity_info{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 30px;
                margin-top: 10px;
                margin-bottom: 22px;
                background-image: linear-gradient(90deg, #fa3838 0%, #fd895f 100%), linear-gradient(#fd895f, #fd895f);
                border-radius: 15px;
                .activity_title {
                  width: 110px;
                  height: 26px;
                  text-align: center;
                  line-height: 26px;
                  font-size: 12px;
                  color: #fb4c42;
                  margin-left: 2px;
                  background: #ffffff;
                  border-radius: 15px;
                  img {
                    vertical-align: middle;
                    margin-right: 4px;
                  }
                }
                .activity_time {
                  display: flex;
                  flex-direction: row;
                  float: right;
                  margin-right: 20px;
                  .timeHas{
                      margin-top: 3px;
                  }
                  >div {
                    display: inline-block;
                  }
                  span {
                    display: inline-block;
                    font-size: 10px;
                    color: #fff;
                  }
                  .time {
                    min-width: 18px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    vertical-align: middle;
                    font-size: 12px;
                    color: #e60012;
                    font-weight: 700;
                    background: #fff;
                    border-radius: 2px;
                    margin: 0 4px;
                    padding: 0 2px;
                  }
                }
              }
              @media screen and (max-width: 800px)  {
                    .activity_info {
                        height: 60px;
                        justify-content: start;
                        .activity_title{
                            height: 54px;
                            line-height: 54px;
                            margin-right: 20px;
                        }
                        .activity_time{
                            flex-direction: column;
                            >span{
                                margin-bottom: 5px;
                            }
                        }
                    }
                }
            }
          }
        }
        .item_remark {
          width: 82px;
          border: 1px solid #e5e5e5;
          resize: none;
          padding: 8px;
          box-sizing: border-box;
          font-size: 12px;
          color: #0d152d;
          border-radius: 4px;
          margin: 0 10px;
          outline: none;
          font-family: "微软雅黑";
        }
        .item_select {
          padding: 0 8px;
          // width: 230px;
          /deep/ {
            input::-webkit-input-placeholder { color: #D9001B; }
            input::-moz-input-placeholder { color: #D9001B; }
            input::-ms-input-placeholder { color: #D9001B; }
          }
          .select_box {
            border: 1px solid #e5e5e5;
            min-height: 80px;
          }
          &.item_select_coupon{
            border: 1px solid #e5e5e5;
            margin: 0 8px;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #D7D7D7;
          }
          /deep/ .el-select .el-select__tags{
            max-height: 120px;
            overflow-y: scroll;
            width: 100%;
            max-width: inherit !important;
          }
        }
        .recommend {
          line-height: 20px;
          color: #e60012;
          margin-right: 10px;
          span {
            width: 28px;
          }
        }
        .delete, .recommend {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60px;
          font-size: 14px;
          background: #fafafa;
          border-radius: 4px;
          border: 1px solid #e5e5e5;
          cursor: pointer;
        }
        .forbidden {
          color: #999999;
        }
      }
    }
    .no_product {
      width: 160px;
      text-align: center;
      font-size: 0;
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      p {
        font-size: 16px;
        color: #949bab;
        line-height: 16px;
        margin-top: 10px;
      }
    }
  }
  .extension_wrapper {
      .linkOne{
          display: inline-block;
          width: 212px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;

      }
    width: 108%;
    .set_extension {
      display: inline-block;
      width: 54px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      color: #ffffff;
      border-radius: 4px;
      background: linear-gradient(0deg, #d75b4a 0%, #d33f3a 100%);
      margin-left: 20px;
      cursor: pointer;
    }
    .set_info {
      input {
        display: inline-block;
        width: 200px;
	      height: 32px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        padding-left: 10px;
        outline: none;
      }
    }
    .set_cancel {
      color: #0d152d;
      border: 1px solid #e5e5e5;
      background: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-live-goods/index.vue